import React from "react";
import ReactDOM from "react-dom/client";
import DavisRentals from "./DavisRentals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<DavisRentals />);
